// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__m_l_f","input":"Input_input__FJCBs","icon":"Input_icon__RjZUy","search":"Input_search__suy2L"};